/* eslint-disable global-require,import/no-mutable-exports */

var validate = void 0;

if (process.env.NODE_ENV === 'production') {
  validate = require('./schema-validator.prod').default;
} else {
  validate = require('./schema-validator.dev').default;
}

export default validate;
//# sourceMappingURL=index.js.map